import { Link } from "react-router-dom";

export const SidebarItem = (props) => {
  return (
    <Link
      className={`${props.isActive ? "sidebar-item-ative" : "sidebar-item"} ${
        props.isDeactive ? "sidebar-deactive" : ""
      }`}
      to={props.isDeactive ? undefined : props.link}
    >
      <img src={props.icon} width="40px" className="pr-10" alt="item" />
      <span>{props.name}</span>
    </Link>
  );
};
